import { ICarrierSource, IOrganizationCarrier } from "@/shared/types"

export const isHighway = (carrier: IOrganizationCarrier) => {
  return carrier.source !== ICarrierSource.APOLLO
}
